// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IDocCommandInfoOverload {
  id: number;
  header: string;
  description: string[];
}
